<div class="resource-configure mb-24">
  <div class="pt-26 ml-72 mr-72">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  </div>
  <div class="p-24 ml-72 mr-72 mt--14 header-section">
    <div class="flex flex-row flex-auto">
      <div class="flex flex-row items-start mt-8">
        <mat-icon (click)="goBack()" class="icon cursor-pointer" svgIcon="arrow_back"></mat-icon>
      </div>
      <div class="flex flex-col ml-12">
        <div class="mat-subtitle-1 fw-600 mb-0">{{'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.RESOURCE_CONFIGURE' | transloco}}</div>
        <div *ngIf="!isLoading; else instanceId" class="flex flex-row resource-config mt-4">
          <div class="mr-12">
            {{instance?.name}}
          </div>
          <span class="vertical-divider mt-6"></span>
          <div class="pl-12 mr-12">
            {{ blueprint?.name }}
          </div>
          <span class="vertical-divider mt-6"></span>
          <div class="pl-12">
            {{ solution?.name }}
          </div>
        </div>
      </div>
      <ng-template #instanceId>
        <div class="skeleton-loader mt-8">
          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="pl-72 pr-72 pt-24 flex flex-col">
    <div class="flex items-center steper-section mb-16">
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': activePage === tbc}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">1</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.PRODUCT_CONFIGURATION' | transloco }}</span>
        <span class="horizontal-line ml-12"></span>
      </div>
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': activePage === exchange}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">2</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.EXCHANGE_CONFIGURATION' | transloco }}</span>
        <span class="horizontal-line ml-12"></span>
      </div>
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': activePage === review}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">3</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.SUMMARY' | transloco }}</span>
      </div>
    </div>

    <mat-divider class="neutral-2"></mat-divider>
    <div class="tab-header mb-16 mt-16">
      <div *ngIf="activePage === tbc" class="flex flex-row tabs-section">
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <div *ngFor="let tbcData of tbcComponents; let last = last" class="mat-subtitle-1 fw-500 fs-16 mb-0 items-center tabs h-40" [ngClass]="{'active fw-700': tbcData.active, 'edited': (tbcData?.form && tbcData?.form[0]?.formGroup.touched)}" (click)="getComponent(tbcData , tbc)">{{tbcData.displayName ? tbcData.displayName : tbcData.name}}<span *ngIf="!last" class="separator ml-16"></span></div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div *ngIf="activePage === exchange" class="flex flex-row tabs-section">
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <div *ngFor="let exchangeData of exchangeComponents; let last = last" class="mat-subtitle-1 fw-500 fs-16 mb-0 flex items-center tabs h-40" [ngClass]="{'active fw-700': exchangeData.active, 'edited': (exchangeData?.form && exchangeData?.form[0]?.formGroup.touched)}" (click)="getComponent(exchangeData , exchange)">{{exchangeData.displayName ? exchangeData.displayName : exchangeData.name}}<span *ngIf="!last">|</span></div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div *ngIf="isComponentLoaded && (activePage === tbc && tbcComponents?.length === 0) || (activePage === exchange && exchangeComponents?.length === 0)" class="flex items-center justify-center pt-64 pb-64 flex-col no-data">
      <img src="/assets/images/no-data.png">
      <div>{{activePage === tbc ? ('INSTANCE_LIST.PRODUCT_PARAMETERS_NOT_AVAILABLE' | transloco) : ('INSTANCE_LIST.EXCHANGE_PARAMETERS_NOT_AVAILABLE' | transloco)}}</div>
    </div>
  </div>
  <div class="flex flex-col pl-72 pr-72" *ngIf="(activePage === tbc && tbcComponents?.length > 0) || (activePage === exchange && exchangeComponents?.length > 0) || activePage === review">
  @if (installationSpecificationForms?.length && activeForm && ( activePage === tbc || activePage === exchange)) {
    <div class="ques-section p-24">
      @for (installationSpecificationForm of installationSpecificationForms;track installationSpecificationForm;) {
        <app-dynamic-form  [dynamicFormModel]="installationSpecificationForm">
        </app-dynamic-form>  
      }
    </div>
  } @else {
    @if (activePage !== review && isComponentLoaded) {
      <div class="flex items-center justify-center pt-64 pb-64 flex-col no-data">
        <img src="/assets/images/no-data.png">
        <div>{{activePage === tbc ? ('INSTANCE_LIST.PRODUCT_PARAMETERS_NOT_AVAILABLE' | transloco) : ('INSTANCE_LIST.EXCHANGE_PARAMETERS_NOT_AVAILABLE' | transloco)}}</div>
      </div>
    }
  }
    <div *ngIf="activePage === review">
      <div class="flex flex-col">
        <ng-container *ngIf="tbcComponents?.length">
          <div class="flex flex-row">
            <div class="basis-full heading fs-20 fw-700 mb-16">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.PRODUCT_CONFIGURATION' | transloco }}</div>
            <div class="flex justify-end cursor-pointer">
              <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
              <div class="heading fs-20 fw-700" (click)="onEdit('tbc')">{{ 'BUTTONS.EDIT' | transloco }}</div>
            </div>
          </div>
          <div class="flex flex-row">
            <div class="flex flex-col service-title w-100-percent">
              <div *ngFor="let tbcReview of tbcComponents" class="component-data mat-subtitle-2 mb-10 word-break-word">
                <div class="component-name overline-font subheading fs-14 mb-16">{{tbcReview?.displayName ? tbcReview?.displayName : tbcReview?.name}}</div>
                <ng-container *ngFor="let formData of tbcReview.form">
                  <app-questionnaire-summary [dynamicFormModel]="formData"></app-questionnaire-summary>
                </ng-container>               
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="exchangeComponents?.length">
          <div class="flex flex-row">
            <div class="basis-full heading fs-20 fw-700 mb-16">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.EXCHANGE_CONFIGURATION' | transloco }}</div>
            <div class="flex justify-end cursor-pointer">
              <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
              <div class="heading fs-20 fw-700" (click)="onEdit('exchange')">{{ 'BUTTONS.EDIT' | transloco }}</div>
            </div>
          </div>
          <div class="flex flex-row">
            <div class="flex flex-col service-title w-100-percent">
              <div *ngFor="let exchangeReview of exchangeComponents" class="component-data mat-subtitle-2 mb-10 word-break-word">
                <div class="component-name overline-font subheading fs-14 mb-16">{{exchangeReview?.displayName ? exchangeReview?.displayName : exchangeReview?.name}}</div>
                <ng-container *ngFor="let formData of exchangeReview.form">
                  <app-questionnaire-summary [dynamicFormModel]="formData"></app-questionnaire-summary>
                </ng-container>               
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<span class="flex-auto"></span>
<div class="summary-header pale max-width-lg mt-auto">
  <div class="flex flex-row justify-center items-center">
    <mat-icon (click)="previous(activePage)" class="icon-sm cursor-pointer mr-8" svgIcon="arrow_back"></mat-icon>
    {{ 'BUTTONS.PREVIOUS' | transloco }}    
    <!-- <button *ngIf="activePage !== review" (click)="skip(activePage)" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 p-16 pl-42 pr-42">
      <mat-icon class="icon-sm cursor-pointer mr-8" svgIcon="close"></mat-icon>
      {{ 'BUTTONS.SKIP_AND_CONTINUE' | transloco }}
    </button> -->
    <button *ngIf="activePage === review" (click)="goBack()" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 p-16 pl-42 pr-42">
      <mat-icon class="icon-sm cursor-pointer mr-8" svgIcon="close"></mat-icon>
      {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
    <button *ngIf="activePage !== review" (click)="continue(activePage)" class="flex justify-items-center items-center mossgreen primary-fg p-16 pl-42 pr-42 ml-auto" type="button" [disabled]="!isContinueDisabled">
      {{ 'BUTTONS.CONTINUE' | transloco }}
      <mat-icon class="icon-sm ml-8" svgIcon="arrow_forward"></mat-icon>
    </button>
    <button *ngIf="activePage === review" (click)="continue(activePage)" [matTooltipHideDelay]="300000" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="disableSubmit ? '' : ('INSTANCE_DETAILS.DISABLED_ICON_TOOLTIP' | transloco)" [disabled]="!disableSubmit" class="submit flex justify-items-center items-center mossgreen primary-fg p-16 pl-42 pr-42" type="button">
      {{ 'BUTTONS.SUBMIT' | transloco }}
    </button>
  </div>
</div>
